module.exports = __webpack_public_path__ + "img/planwave-3.b2cdde0e.png";